export enum ActionType {
    Create = 1,
    Update = 2,
    Delete = 3,
    InvalidLoginAttempt = 4,
    InvalidResetPassword = 5,
    ChangeOwner = 6,
    MoveToTrash = 7,
    Restore = 8,
    ShareExistingContent = 9,
    DeleteResponses = 10,
    CreateAccessRequest = 11,
    AcceptAccessRequest = 12,
    RejectAccessRequest = 13,
    MarkAsCompleted = 14, // Task module related
    MarkAsUncompleted = 15, // Task module related
    CheckListSetApplicable = 16, // CheckList module related
    CheckListSetNotApplicable = 17, // CheckList module related
    CheckPointSetApplicable = 18, // CheckList module related
    CheckPointSetNotApplicable = 19, // CheckList module related
    Pinned = 20, // NewsFeed module related
    RemovedPin = 21, // NewsFeed module related
    OpenSupportSession = 22,
    InternalSupportMessage = 24,
    ChainformationSupportMessage = 25,
    CheckListSetGlobalMobileOn = 26, // CheckList module related
    CheckListSetGlobalMobileOff = 27, // CheckList module related
    Published = 28, // document/file/form published by system service
    Unpublished = 29, // document/file/form unpublished by system service
    TransferOwnership = 30, // transfer ownership
    SuperAdminViewAccess = 101,
    NotificationCategoryChanged = 201,
}
